import { render, staticRenderFns } from "./CustomerSchemeList.vue?vue&type=template&id=2fabf5ea&scoped=true&"
import script from "./CustomerSchemeList.vue?vue&type=script&lang=js&"
export * from "./CustomerSchemeList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSchemeList.vue?vue&type=style&index=0&id=2fabf5ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabf5ea",
  null
  
)

export default component.exports